module.exports = __webpack_public_path__ + "static/media/image_37.746fad27.png";